import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Switch } from '../../Components/Form';
import { usePreference } from '../../Data/Preference';
import Radio from '../../Components/Form/Fields/Radio';

const Preferences = ({isOpen, setIsOpen}) => {
    return <Modal title="Preferences" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner />}
    </Modal>
}

const Inner = () => {
    const [hideCompleted, setHideCompleted] = usePreference('work:hideCompleted', false);
    const [directionsApp, setDirectionsApp] = usePreference('work:directionsApp', 'googleMaps');

    const data = {
        hideCompleted,
        directionsApp,
    }

    const save = (d) => {
        setHideCompleted(d.hideCompleted);
        setDirectionsApp(d.directionsApp);
    }

    return <Form data={data} onSubmit={save} closeModalOnSubmit>
        <Switch
            name="hideCompleted"
            label="Hide completed"
            innerLabel="Hide completed jobs"
        />
        <Radio
            name="directionsApp"
            label="Open directions in"
            options={[
                {label: 'Apple Maps', value: 'appleMaps'},
                {label: 'Google Maps', value: 'googleMaps'},
            ]}
        />
        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default Preferences;
